import React from 'react';
import { Modal as DefaultModal } from '../Modal';
import { MessageBounceProvider, useComponentContext } from '../../context';
export function MessageBounceModal({ MessageBouncePrompt, ...modalProps }) {
    const { Modal = DefaultModal } = useComponentContext();
    return (React.createElement(Modal, { className: 'str-chat__message-bounce-modal', ...modalProps },
        React.createElement(MessageBounceProvider, null,
            React.createElement(MessageBouncePrompt, { onClose: modalProps.onClose }))));
}
